import React from 'react';
import { Frame, Icon, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const Course = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
        style={{ background: SageTokens.COLOR_PALETTE.WHITE }}
      >
        <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
          <MockItem color="#89CAF8" width="35%" />
        </Frame>
        <Frame
          align={
            Frame.ALIGNMENTS[breakpoints.sm ? 'CENTER_RIGHT' : 'END_SPREAD']
          }
          direction={
            Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']
          }
          gap={Frame.GAPS[breakpoints.sm ? '2XS' : 'MD']}
        >
          {Array(breakpoints.sm ? 3 : 4)
            .fill()
            .map((_, index) => (
              <MockItem
                color={
                  SageTokens.COLOR_PALETTE[
                    breakpoints.sm ? 'PRIMARY_200' : 'PRIMARY_100'
                  ]
                }
                key={`landing-page-header-${index}`}
                width={breakpoints.sm ? undefined : '25%'}
              />
            ))}
        </Frame>
      </Frame>
      <Frame
        align={Frame.ALIGNMENTS.CENTER_CENTER}
        className={hideOrExpandSection(1)}
        background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
        padding={Frame.PADDINGS.LG}
      >
        <MockItem color="#57B3F4" height={12} width="17%" />
        <MockItem color="#86C8FD" height={12} width="47%" />
        <MockItem borderRadius={8} color="#89CAF8" height={36} width={100} />
      </Frame>
      <Frame
        className={hideOrExpandSection(1)}
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : '2XL']}
      >
        <Frame>
          <Frame>
            <MockItem
              className={hideOrExpandSection(1)}
              color="#57B3F4"
              height={12}
              width={124}
            />
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
          </Frame>
          <Frame>
            <MockItem
              className={hideOrExpandSection(1)}
              color="#57B3F4"
              height={12}
              width={124}
            />
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
            <Frame
              className={hideOrExpandSection(2)}
              direction={Frame.DIRECTIONS.HORIZONTAL}
            >
              <Frame
                align={Frame.ALIGNMENTS.CENTER_CENTER}
                background={SageTokens.COLOR_SLIDERS.PRIMARY_100}
                padding={Frame.PADDINGS.LG}
              >
                <Icon
                  color={Icon.COLORS.PRIMARY_200}
                  icon={Icon.ICONS.PLAY}
                  size={Icon.SIZES['XL']}
                />
              </Frame>
              <Frame className={hideOrExpandSection(3)}>
                <MockItem color="#57B3F4" height={12} width="50%" />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="100%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={12}
                  width="75%"
                />
              </Frame>
            </Frame>
          </Frame>
        </Frame>
        {breakpoints.sm || (
          <Frame
            align={Frame.ALIGNMENTS.TOP_CENTER}
            className={hideOrExpandSection(2)}
            style={{ width: '40%' }}
          >
            <Frame
              align={Frame.ALIGNMENTS.CENTER_CENTER}
              border={Frame.BORDERS.DEFAULT}
              borderRadius={Frame.BORDER_RADII.MD}
              gap={Frame.GAPS.SM}
              padding={Frame.PADDINGS.LG}
            >
              <MockItem
                color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                height={64}
                width={64}
              />
              <MockItem
                color={SageTokens.COLOR_PALETTE.PRIMARY_200}
                height={12}
                width="75%"
              />
              <MockItem
                color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                height={8}
                width="100%"
              />
              <MockItem
                color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                height={8}
                width="100%"
              />
            </Frame>
            <Frame
              border={Frame.BORDERS.DEFAULT}
              borderRadius={Frame.BORDER_RADII.MD}
              gap={Frame.GAPS.SM}
              padding={Frame.PADDINGS.LG}
            >
              <MockItem
                color={SageTokens.COLOR_PALETTE.PRIMARY_200}
                height={12}
                width="95%"
              />
              <Frame gap={Frame.GAPS['2XS']}>
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="75%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="54%"
                />
              </Frame>
              <Frame gap={Frame.GAPS['2XS']}>
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="75%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="54%"
                />
              </Frame>
              <Frame gap={Frame.GAPS['2XS']}>
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="75%"
                />
                <MockItem
                  color={SageTokens.COLOR_PALETTE.PRIMARY_100}
                  height={8}
                  width="54%"
                />
              </Frame>
            </Frame>
          </Frame>
        )}
      </Frame>
    </>
  );
};

Course.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
